// extracted by mini-css-extract-plugin
export default {"root":"N41q3_Zq","widgetPreview":"_3qOg9_bW"};